export const team = [
  {
    name: 'Sahil Gonsalves',
    role: 'Founder',
    photo: 'sahil.jpg',
    bio: 'Consulting experience in the energy sector, specializing in hydrogen technologies and solar power systems',
    linkedin: 'https://www.linkedin.com/in/sahil-gonsalves-2aa4951b0'
  },
  {
    name: 'Sai Krishna',
    role: 'Co-founder',
    photo: 'sai.jpg',
    bio: 'Leads initiatives in regulatory policy and credit risk management',
    linkedin: 'https://www.linkedin.com/in/sai-krishna-arelly-683759197'
  }
]